exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.svg-ticker-list[data-v-46a7f860]{overflow:hidden;padding:0;margin:0;position:relative}ul.svg-ticker-list>li[data-v-46a7f860]{padding:0;margin:0;float:left;position:absolute;display:inline-block}ul.svg-ticker-list>li>svg[data-v-46a7f860]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46a7f860","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/SVGTicker.vue
// module id = 630
// module chunks = 0